import {
  can,
} from "../../shared/auth/access";
import {
  TableState,
} from "../../shared/components/TableState";
import type {
  useSuppliersWorkspace,
} from "./useSuppliersWorkspace";

export function SupplierQuality({ model }: { model: ReturnType<typeof useSuppliersWorkspace> ;}) {
  const { user, supplierTab, supplierActionPending, qualityScope, setQualityScope, eligibility, qualificationCase, qualificationLabels, blockingReasonLabels, checkEligibility, assignCapabilitySite, createQualityCase, loadQualityCase, submitQualityCase, decideQualityCase, suspendQualityCase } = model;
  return (<>{supplierTab === "quality" ? (
    <>
      <div className="section-heading compact">
        <div>
          <span className="section-kicker">
            Resmî kalite yeterliliği
          </span>
          <h3>Performanstan bağımsız kalite kararı</h3>
        </div>
      </div>
      <p>
        Teslimat performansı bilgi amaçlıdır; onaylı tedarikçi
        durumunu kendiliğinden oluşturmaz.
      </p>
      <div className="inline-form-grid">
        <label>
          Tesis kodu
          <input
            value={qualityScope.siteCode}
            onChange={(event) =>
              setQualityScope((current) => ({
                ...current,
                siteCode: event.target.value,
              }))
            }
          />
        </label>
        <label>
          Kalite kategorisi
          <select
            value={qualityScope.category}
            onChange={(event) =>
              setQualityScope((current) => ({
                ...current,
                category: event.target.value,
              }))
            }
          >
            <option>Hammadde</option>
            <option>Ambalaj</option>
          </select>
        </label>
        <label>
          Ürün grubu kodu
          <input
            value={qualityScope.productGroupCode}
            onChange={(event) =>
              setQualityScope((current) => ({
                ...current,
                productGroupCode: event.target.value,
              }))
            }
          />
        </label>
        {can(user, "supplier.qualification.decide") ? (
          <>
            <label>
              Şartlı onay azami miktarı
              <input
                type="number"
                min="0"
                value={qualityScope.conditionalLimit}
                onChange={(event) =>
                  setQualityScope((current) => ({
                    ...current,
                    conditionalLimit: event.target.value,
                  }))
                }
              />
            </label>
            <label>
              Şartlı onay birimi
              <input
                value={qualityScope.conditionalUnit}
                onChange={(event) =>
                  setQualityScope((current) => ({
                    ...current,
                    conditionalUnit: event.target.value,
                  }))
                }
              />
            </label>
          </>
        ) : null}
      </div>
      <div className="inline-form-actions">
        {can(user, "supplier.identity.manage") ? (
          <button
            className="secondary-button"
            disabled={supplierActionPending}
            onClick={assignCapabilitySite}
          >
            Tesis kapsamını yetkilendir
          </button>
        ) : null}
        <button
          className="secondary-button"
          disabled={
            supplierActionPending ||
            !can(user, "supplier.qualification.read")
          }
          onClick={checkEligibility}
        >
          Uygunluğu sunucudan denetle
        </button>
        <button
          className="secondary-button"
          disabled={
            supplierActionPending ||
            !can(user, "supplier.qualification.read")
          }
          onClick={loadQualityCase}
        >
          Mevcut kalite dosyasını getir
        </button>
        {can(user, "supplier.qualification.evaluate") ? (
          <button
            className="secondary-button"
            disabled={supplierActionPending}
            onClick={createQualityCase}
          >
            Değerlendirme dosyası aç
          </button>
        ) : null}
        {can(user, "supplier.qualification.evaluate") &&
          qualificationCase &&
          !["APPROVED", "CONDITIONAL", "UNDER_REVIEW"].includes(
            qualificationCase.status ?? "",
          ) ? (
          <button
            className="secondary-button"
            disabled={supplierActionPending}
            onClick={submitQualityCase}
          >
            Karara gönder
          </button>
        ) : null}
        {can(user, "supplier.qualification.decide") &&
          qualificationCase?.status === "UNDER_REVIEW" ? (
          <>
            <button
              className="approve-button"
              disabled={supplierActionPending}
              onClick={() => decideQualityCase("APPROVED")}
            >
              Kalite onayı ver
            </button>
            <button
              className="secondary-button"
              disabled={supplierActionPending}
              onClick={() => decideQualityCase("CONDITIONAL")}
            >
              Şartlı onay ver
            </button>
            <button
              className="secondary-button"
              disabled={supplierActionPending}
              onClick={() => decideQualityCase("REJECTED")}
            >
              Reddet
            </button>
          </>
        ) : null}
        {can(user, "supplier.qualification.suspend") &&
          ["APPROVED", "CONDITIONAL"].includes(
            qualificationCase?.status ?? "",
          ) ? (
          <button
            className="secondary-button"
            disabled={supplierActionPending}
            onClick={suspendQualityCase}
          >
            Kalite onayını askıya al
          </button>
        ) : null}
      </div>
      {eligibility ? (
        <div className="table-state" role="status">
          <strong>
            {eligibility.eligible
              ? "Kapsamda uygun"
              : "Kapsamda uygun değil"}
          </strong>
          <p>
            {
              qualificationLabels[
              eligibility.qualificationStatus
              ]
            }{" "}
            ·{" "}
            {eligibility.blockingReasons.length
              ? eligibility.blockingReasons
                .map(
                  (item) =>
                    blockingReasonLabels[item] ??
                    "Uygunluk koşulu sağlanmadı",
                )
                .join(", ")
              : "Engel yok"}
          </p>
          <small>
            Sunucu değerlendirme zamanı:{" "}
            {new Date(eligibility.evaluatedAt).toLocaleString(
              "tr-TR",
            )}
          </small>
        </div>
      ) : (
        <TableState
          title="Kalite kapsamı değerlendirilmedi"
          description="Tesis, kategori ve ürün grubunu girerek resmî uygunluğu sunucudan denetleyin."
        />
      )}
    </>
  ) : null}</>);
}
